import { action, computed, makeObservable, observable, values } from 'mobx';

import {
  ISecretChatAccessRequest,
  SecretChatAccessRequestStatus,
} from 'APP/model/e2ee/e2eeModel.types';
import { IGroupData } from 'APP/model/group/groupModel.types';
import { Root } from 'STORE';
import { ChatGroup } from 'STORE/Groups/ChatGroup';
import { Groups } from 'STORE/Groups/Groups';

export class SecretGroup extends ChatGroup {
  @observable isUnlocked = false;
  @observable chatAccessRequestsCount = 0;
  @observable private devicesRequests = observable.map<string, ISecretChatAccessRequest>(
    {},
    { deep: true }
  );

  constructor(group: IGroupData, groups: Groups, root: Root) {
    super(group, groups, root);
    makeObservable(this);
    this.chatAccessRequestsCount = group.activeChatAccessRequestCount;
  }

  get isSecretGroup(): boolean {
    return true;
  }

  @computed
  get devicesRequestsAccessList(): readonly ISecretChatAccessRequest[] {
    return values(this.devicesRequests).filter((item) => {
      console.log(item.status, item.status === SecretChatAccessRequestStatus.Requested);
      return item.status === SecretChatAccessRequestStatus.Requested;
    });
  }

  @action
  setIsUnlocked(): void {
    this.isUnlocked = true;
  }

  @action
  setDevicesRequests(devices: ISecretChatAccessRequest[]): void {
    devices.forEach((device: ISecretChatAccessRequest) => {
      this.devicesRequests.set(device.deviceId, device);
    });
  }

  @action
  setDevicesRequestStatus(deviceId: string, status: SecretChatAccessRequestStatus): void {
    const request = this.devicesRequests.get(deviceId);
    if (!request) {
      return;
    }
    request.status = status;
    this.devicesRequests.set(deviceId, request);
  }

  @action
  setChatAccessRequestsCount(count: number): void {
    this.chatAccessRequestsCount = count;
  }

  @action
  removeChatAccessRequest(deviceId: string): void {
    this.devicesRequests.delete(deviceId);
  }

  getDevicesRequest(deviceId: string): ISecretChatAccessRequest | null {
    return this.devicesRequests.get(deviceId) || null;
  }
}
